import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer'
import 'nodelist-foreach-polyfill'
import 'whatwg-fetch'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
